import loginModule from "../loginModule.js";
import { EnvironmentUrls, Popover } from "Roblox";

function loginController($scope, $httpParamSerializerJQLike, loginService, urlConstants, loginConstants) {
    "ngInject";
    var signUpUrl = EnvironmentUrls.websiteUrl + loginConstants.urls.signUpRedirect;

    $scope.loginData = {
        signUpUrl: signUpUrl
    };

    $scope.init = function () {
        if (Popover) {
            Popover.init();
        }
        var returnUrl = loginService.getReturnUrl();
        if (returnUrl) {
            $scope.appendReturnUrlToSignUpUrl(returnUrl);
            return;
        }
    }

    $scope.appendReturnUrlToSignUpUrl = function (returnUrl) {
        if (!returnUrl) {
            return;
        }

        var params = {
            returnUrl: returnUrl
        };

        var returnUrlQueryString = urlConstants.urlQueryStringPrefix + $httpParamSerializerJQLike(params);
        $scope.loginData.signUpUrl = signUpUrl + returnUrlQueryString;
    }

    $scope.init();
}

loginModule.controller("loginController", loginController);

export default loginController;